import z from "zod";

export const addInterestActionSchema = () =>
  z.object({
    interestActionType: z.object({
      label: z.string().min(1, "Interest Action Type is required*"),
      value: z.coerce.number().int().positive("Invalid Interest Action Type*"),
      color: z.string().nullish(),
    }),
    comment: z.string().optional(),
  });

export const addInterestSchema = () =>
  z.object({
    propertyUids: z
      .array(z.string().min(1, "Property is required*"))
      .min(1, "Atleast one property is required")
      .max(5, "Maximum selection 5"),
  });
